// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__cEfaV","empty":"ModalGraph_empty__2VniY"};